import Modals from "../components/Modal/Modal";
import { Icon } from "@iconify/react";
import WarningIcon from "../assets/icons/warning.svg";

// Modal appears when the sponsor captures other event QR Code
export const InvalidEventModal = ({ showModal, setModal, onCloseModal }) => {
  return (
    <Modals
      showModal={showModal}
      setModal={setModal}
      onCloseModal={onCloseModal}
    >
      <div className="modal-error">
        <div className="modal-error__icon">
          <Icon icon="mdi:alert" width="48" height="48" />
        </div>
        <p className="modal-error__text">Invalid QR code!</p>
        <p style={{ color: "#6b7280", fontSize: "14px", marginTop: "8px" }}>
          This attendee doesn't belong to this event
        </p>
      </div>
    </Modals>
  );
};

// Modal appears when the QR Code is invalid
export const WarningModal = ({
  showModal,
  setModal,
  modalText,
  modalSubtext,
  onCloseModal,
}) => {
  return (
    <Modals
      showModal={showModal}
      setModal={setModal}
      onCloseModal={onCloseModal}
      faddedBg={true}
    >
      <div className="modal-error">
        <div className="modal-error__icon">
          <img src={WarningIcon} alt="Warning" width="60" height="60" />
        </div>
        <div className="modal-error__content">
          <p className="modal-error__text">{modalText}</p>
          {modalSubtext && (
            <p className="modal-error__subtext">{modalSubtext}</p>
          )}
        </div>
      </div>
    </Modals>
  );
};

// Success modal when event access is approved
export const AddedEventDisplayModal = ({
  addedEventModal,
  setAddedEventModal,
  onCloseModal,
  accessEventClickHandler,
  addedEventDatails,
  closeButton = true,
}) => {
  return (
    <Modals
      showModal={addedEventModal}
      setModal={setAddedEventModal}
      closeButton={closeButton}
      onCloseModal={onCloseModal}
      faddedBg={true}
    >
      <div className="modal-success">
        <div className="modal-success__icon">
          <Icon icon="ep:success-filled" width="60" height="60" />
        </div>
        <p className="modal-success__text">
          You have already access to <strong>{addedEventDatails?.eventName}</strong>
        </p>
        <button
          className="modal-success__btn"
          onClick={accessEventClickHandler}
        >
          Access Event
        </button>
      </div>
    </Modals>
  );
};

// Error modal for invalid sponsor code
export const InvalidSponsorCodeModal = ({
  showModal,
  setModal,
  onCloseModal,
}) => {
  return (
    <Modals
      showModal={showModal}
      setModal={setModal}
      onCloseModal={onCloseModal}
      faddedBg={true}
    >
      <div className="modal-error">
        <div className="modal-error__icon">
          <img src={WarningIcon} alt="Warning" width="60" height="60" />
        </div>
        <p className="modal-error__text">Invalid Sponsor Code</p>
      </div>
    </Modals>
  );
};
